/*
 * The set's price, and carrying the buy box's choices onto its members.
 *
 * Loaded by snippets/hoopers-bundle-offer, which owns the add-to-cart payload.
 * This file owns the two things that sit either side of it: what the button
 * PROMISES, and what the member rows start out holding.
 *
 * 🔴 The button used to print the flat bundle price. A shopper who added a
 * patch read "249 ₪" and was charged 259 at the checkout — the one thing this
 * upsell pipe must never do. It was already wrong for the buy box's own extras
 * in set mode; adding per-member options would have made it wrong for everyone.
 * `hbxTotal` recomputes bundle + buy-box extras + every member's extras on
 * every change, and the snippet asks for it instead of a fixed string.
 */
(function () {
  if (window.__hbxExtras) return;
  window.__hbxExtras = 1;

  var PRINT_FEE = 10;

  /** Everything the shopper has added on top of the set, in shekels. */
  window.hbxExtras = function (hb) {
    var total = 0;

    /* The buy box's own upsells ride on the main line, so they are part of
       what the set costs. Read the same way snippets/hoopers-upsells prices
       them: a checked control with an empty value is a no-op choice. */
    var box = document.querySelector('[data-hup]');
    if (box) {
      var picked = box.querySelectorAll('.hup__in:checked');
      for (var i = 0; i < picked.length; i++) {
        var el = picked[i];
        var val = el.hasAttribute('data-hup-print') ? '1' : el.value;
        if (!val) continue;
        total += parseFloat(el.getAttribute('data-hup-price')) || 0;
      }
    }

    var rows = hb.querySelectorAll('[data-hb-print-row]');
    for (var r = 0; r < rows.length; r++) {
      var row = rows[r];
      var p = row.querySelector('[data-hb-print]');
      if (p && p.checked) total += PRINT_FEE;
      var pa = row.querySelector('[data-hb-patch]:checked');
      if (pa && pa.value) total += parseFloat(pa.getAttribute('data-hb-fee')) || 0;
      var ve = row.querySelector('[data-hb-ver]:checked');
      if (ve && ve.value) total += parseFloat(ve.getAttribute('data-hb-fee')) || 0;
    }
    return total;
  };

  /*
   * Carry the buy box's choices onto the members.
   *
   * Someone buying the home and away shirt of the same player wants the same
   * name on both; typing it twice is a chore and forgetting the second one is a
   * set that arrives half-personalised. Each member is seeded from what was
   * picked above, filtered by what that member is actually allowed to have — a
   * partner that does not offer printing never receives a name, and a partner
   * whose patch list lacks the chosen patch is left alone.
   *
   * 🔴 Seeded once per distinct buy-box state. Without the guard, un-ticking a
   * seeded option would be re-applied on the next change and the shopper could
   * not refuse it. Existing typing is never overwritten.
   */
  window.hbxSeed = function (hb) {
    var box = document.querySelector('[data-hup]');
    if (!box) return false;

    var patchEl = null, verEl = null;
    var radios = box.querySelectorAll('.hup__in[type="radio"]:checked');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].hasAttribute('data-hup-pro')) verEl = radios[i];
      else patchEl = radios[i];
    }
    var printEl = box.querySelector('[data-hup-print]');
    var nameEl = box.querySelector('[data-hup-name]');
    var numEl = box.querySelector('[data-hup-num]');

    var patch = patchEl ? patchEl.value : '';
    var ver = verEl ? verEl.value : '';
    // 28/10/26: an opened-but-not-added print (data-hup-pending) is not a print.
    var wantsPrint = !!(printEl && printEl.checked && !printEl.hasAttribute('data-hup-pending'));
    var name = nameEl ? nameEl.value : '';
    var num = numEl ? numEl.value : '';

    var key = [patch, ver, wantsPrint ? '1' : '0', name, num].join('|');
    if (hb.dataset.hbxSeed === key) return false;
    hb.dataset.hbxSeed = key;

    var rows = hb.querySelectorAll('[data-hb-print-row]');
    for (var r = 0; r < rows.length; r++) {
      var row = rows[r];

      if (patch) {
        var pOpts = row.querySelectorAll('[data-hb-patch]');
        for (var a = 0; a < pOpts.length; a++) {
          if (pOpts[a].value === patch) pOpts[a].checked = true;
        }
      }
      if (ver) {
        var vOpts = row.querySelectorAll('[data-hb-ver]');
        for (var b = 0; b < vOpts.length; b++) {
          if (vOpts[b].value === ver) vOpts[b].checked = true;
        }
      }

      var rp = row.querySelector('[data-hb-print]');
      if (rp && wantsPrint) {
        rp.checked = true;
        row.classList.add('is-on');
        var rn = row.querySelector('[data-hb-print-name]');
        var rq = row.querySelector('[data-hb-print-num]');
        if (rn && !rn.value) rn.value = name;
        if (rq && !rq.value) rq.value = num;
      }
    }
    return true;
  };
})();
